/*
    Note: if you update these breakpoints, please make sure to update the mobile
    breakpoints in the GigCardCarouselWrapper/RecentlyViewedGigs styles.scss file as well
*/
export const GIG_GRID_XLRG = 1240;
export const GIG_GRID_LRG = 899;
export const GIG_GRID_MED = 750;
export const GIG_GRID_SML = 530;
